/* Paintroad analytics helper. window.prTrack("pr_event_name", { ...params }).
   Sends to Shopify customer events (custom pixels), GTM dataLayer, gtag and Meta pixel when present. */
(function () {
  if (window.prTrack) return;

  function send(name, params) {
    var data = params || {};
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === "function") {
        Shopify.analytics.publish(name, data);
      }
    } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      var payload = { event: name };
      for (var k in data) if (Object.prototype.hasOwnProperty.call(data, k)) payload[k] = data[k];
      window.dataLayer.push(payload);
    } catch (e) {}
    try {
      if (typeof window.gtag === "function") window.gtag("event", name, data);
    } catch (e) {}
    try {
      if (typeof window.fbq === "function") window.fbq("trackCustom", name, data);
    } catch (e) {}
  }

  window.prTrack = function (name, params) {
    if (!name) return;
    if (window.Shopify && Shopify.designMode) return;
    send(String(name), params);
  };
})();
